import React, { useEffect, useState } from "react";
import MainLayout from "../../layout/MainLayout";
import CoversureLogo from "../../assets/svg/coversure-logo.svg";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import PrimaryButton from "../../components/Button/PrimaryButton";
import TextInput from "../../components/TextInput";
import { useFormik } from "formik";
import { validationSchema } from "../../utils/validation/customerFormValidation";
import { InputAdornment } from "@mui/material";
import { resetLogin, updatelogin } from "../../store/reducers/authentication";
import { handleSendOtp } from "../../store/reducers/authentication/apiThunk";
import { AppDispatch } from "../../store/store";
import { showToast } from "../../components/Toast";
import VideoModal from "./VideoModal";
import VideoPreview1 from "../../assets/svg/Youtube thumbnail.svg";
import VideoPreview2 from "../../assets/svg/Youtube thumbnail2.svg";
import PlayCircleFilledWhiteOutlinedIcon from "@mui/icons-material/PlayCircleFilledWhiteOutlined";
function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [isOpen, setOpen] = useState(false);
  const [link, setLink] = useState("");
  function handleChange() {
    setOpen(!isOpen);
  }
  useEffect(() => {
    dispatch(resetLogin());
  }, []);
  const formik = useFormik({
    initialValues: {
      mobileNo: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      const data = {
        mobileNo: values?.mobileNo,
      };
      try {
        const response: any = await dispatch(handleSendOtp(data)).unwrap();
        console.log("response", response);
        if (response?.status === 1) {
          dispatch(updatelogin(values));
          navigate(ROUTE_PATH.VERIFY_OTP);
          showToast(response?.data);
        }
      } catch (error) {
        // showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    },
  });
  return (
    <MainLayout>
      <div className="flex justify-center flex-col items-center w-[100%] sm:h-[100vh] lg:px-[73px]">
        <img
          src={CoversureLogo}
          alt="CoversureLogo"
          className="lg:w-[400px] w-[175px] mt-[50px] lg:mt-[20px] lg:mb-[20px]"
        />
        <div className="text-center lg:text-[30px] text-[22px] lg:leading-[32px] font-semibold lg:mt-[50px] mt-[15px] lg:mb-[15px] mb-[7px] tracking-tighter text-text-color-5">
          Enter your mobile number
        </div>
        <div className="text-center lg:text-[18px] text-[15px] lg:leading-[22px] leading-[18px] tracking-tight text-text-color-5 pb-[40px]">
          Please enter the mobile number that was
          <br />
          used for buying the product
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className="space-y-4 sm:w-[80%] w-[100%]"
        >
          <div className="">
            <TextInput
              name="mobileNo"
              fullWidth
              value={formik.values.mobileNo}
              onChange={(e: any) => {
                const value = e.target.value;
                const regex = /^[0-9]*$/;
                if (value === "" || regex.test(value)) {
                  formik.setFieldValue("mobileNo", value);
                }
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.mobileNo && Boolean(formik.errors.mobileNo)}
              helperText={formik.touched.mobileNo && formik.errors.mobileNo}
              inputProps={{
                placeholder: "10 digit mobile number",
                maxLength: 10,
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment
                      style={{
                        borderRight: "1px solid #070C1A33",
                        margin: "0",
                        paddingRight: "8px",
                      }}
                      position="start"
                    >
                      +91
                    </InputAdornment>
                  ),
                },
              }}
            />
          </div>
          <div>
            <PrimaryButton
              label={
                <div className="flex items-center justify-center w-[100%] font-black">
                  <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] ">
                    Send OTP
                  </div>
                </div>
              }
              type="submit"
              classname="w-[100%] lg:w-[80%] mx-auto mt-[20px] lg:mt-[66px]"
            />
          </div>
        </form>
        <div className="flex w-[100%] mt-[24px] lg:mt-[32px]">
          <div
            className="w-[50%] flex flex-col justify-center items-end mr-[5px]"
          >
            <div className="w-fit cursor-pointer" onClick={() => {
              setLink("https://www.youtube.com/watch?v=kJVSGNRp29w");
              handleChange();
            }}>
              <img
                src={VideoPreview1}
                alt="VideoPreview"
                className="w-[204px] h-[108px] hidden lg:block rounded-[2px]"
              />
              <div className="mt-[12px] w-[100%] text-center">
                <PlayCircleFilledWhiteOutlinedIcon
                  style={{
                    color: "#0040FF",
                    marginRight: "10px",
                  }}
                />
                <span className="text-text-color-9 underline text-[13px] lg:text-[16px]">
                  See how it works
                </span>
              </div>
            </div>
          </div>
          <div
            className="w-[50%] flex flex-col justify-center items-start ml-[5px]"
            
          >
            <div className="w-fit cursor-pointer" onClick={() => {
              setLink("https://www.youtube.com/watch?v=N9UAo7ZF3jo");
              handleChange();
            }}>
              <img
                src={VideoPreview2}
                alt="VideoPreview"
                className="w-[204px] h-[108px] hidden lg:block rounded-[2px]"
              />
              <div className="mt-[12px] w-[100%] text-center">
                <PlayCircleFilledWhiteOutlinedIcon
                  style={{
                    color: "#0040FF",
                    marginRight: "10px",
                  }}
                />
                <span className="text-text-color-9 underline text-[13px] lg:text-[16px]">
                  कैसे उपयोग करे
                </span>
              </div>
            </div>
          </div>
        </div>
        <VideoModal isOpen={isOpen} close={handleChange} videoUrl={link} />
      </div>
    </MainLayout>
  );
}

export default Login;
